/**
 * Supabase client with Auth support.
 *
 * Uses the official @supabase/supabase-js SDK for authentication.
 * The same REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY
 * env vars used by client.ts are reused here.
 */

import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL ?? "";
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY ?? "";

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.warn("Supabase env vars not set — auth will not work");
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
